'use strict';

module.exports = require('./Autowhatever').default;


//////////////////
// WEBPACK FOOTER
// ../react-autowhatever/dist/index.js
// module id = 1664
// module chunks = 25